import apiPaths from '../api-paths.js';

export default {
  show(id) {
    return axios.get(`${ apiPaths.CRM }/subscription-settlement-items/${ id }`);
  },
  update(item) {
    return axios.put(`${ apiPaths.CRM }/subscription-settlement-items/${ item.id }`, {
      subscriptionsettlementitems: item,
    });
  },
  delete(id) {
    return axios.delete(`${ apiPaths.CRM }/subscription-settlement-items/${ id }`);
  },
};
